import React, {useEffect} from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Salary = (props) => {
  const handleClick = (id,value) => {
    props.setSalary(id,value)
    props.history.goBack()
  }

  useEffect(() => window.scrollTo(0,0));

  const value = [
    {id: 'level1', text: 'ไม่เกิน 15,000'},
    {id: 'level2', text: '15,001 - 30,000'},
    {id: 'level3', text: '30,001 - 50,000'},
    {id: 'level4', text: '50,001 - 100,000'},
    {id: 'level5', text: '100,001 - 500,000'},
    {id: 'level6', text: '500,001 - 1,000,000'},
    {id: 'level7', text: 'มากกว่า 1,000,000'},
  ]

  return (
    <Layout title={'รายได้ต่อเดือน'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกรายได้ต่อเดือน (บาท)</h4>
      <Row>
        {
          value.map(element =>
            <StyledCol key={element.id}>
              <Text onClick={() => handleClick(element.id,element.text)}>{element.text}</Text>
              <Divider floatRight={true}/>
            </StyledCol>
          )
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setSalary: actions.setSalary,
}

const SalaryWithConnect = connect(null, mapDispatchToProps)(Salary)

export default SalaryWithConnect
